import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EditStudentComponent } from './edit-student.component';

import { UserDataComponent } from './user-data/user-data.component';
import { UserPasswordComponent } from './user-password/user-password.component';
import { UserBindComponent } from './user-bind/user-bind.component';

import { UserNewsComponent } from './user-news/user-news.component';

import { SharedModule } from '../../shared/shared.module';
import { EditStudentRoutingModule } from './edit-student-routing.module';
import { BindModalModule } from './bind-modal/bind-modal.module';
//服务
import { EditStudentService } from './edit-student.service';
// import { CoreModule } from '../../core/core.module';
@NgModule({
  imports: [
    CommonModule, SharedModule, EditStudentRoutingModule, BindModalModule,
    // CoreModule,
    RouterModule
  ],
  declarations: [EditStudentComponent, UserDataComponent, UserPasswordComponent, UserBindComponent,
    UserNewsComponent,
  ],
  exports: [EditStudentComponent],
  providers: [EditStudentService],
})
export class EditStudentModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user-info/edit-student/edit-student.module.ts